import { Suspense, useEffect, useState } from "react";
import { Drawer, Layout } from "antd";
import { Outlet } from "react-router-dom";
import SideBar from "./SideBar";
import AppHeader from "./AppHeader/AppHeader";
import { useAuthLayoutContainer } from "./useAuthLayoutContainer";
import { NavigationRoutes } from "../../navigation/NavigationRoutes";
import Logo from "@Assets/images/Frame.png";
import CircleCheckIcon from "@Assets/icons/dashboard/circle-green.svg";
import LogoLoader from "@Components/LogoLoader/LogoLoader";
const { Header, Content, Footer } = Layout;

const AppLayout = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const { route, selectedKey, moduleTitle, navigate } =
    useAuthLayoutContainer();

  const sideBarParams = { route, selectedKey, navigate };
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (moduleTitle) {
      document.title = `${moduleTitle} - Local Locker`;
    } else {
      document.title = "Local Locker";
    }
  }, [moduleTitle]);

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  return (
    <div className="h-screen bg-gray-100 font-mont overflow-hidden">
      {/* App Header - Full width at top */}
      <Header
        className="bg-white ml-auto lg:w-[calc(100%-var(--side-bar-width))] !h-[70px] flex items-center justify-between  border-b border-app-border flex-shrink-0 fixed top-0 left-1 right-0 z-50"
        style={{
          padding: "0px 20px",
          background: "#ffffff",
        }}
      >
        {/* Left side - Logo and Admin Dashboard text */}
        <div className="flex items-center gap-4">
          {isMobileView && (
            <div
              onClick={(e) => {
                if (e && e.stopPropagation) e.stopPropagation();
                setIsSidebarVisible(true);
              }}
              className="hamburger-btn cursor-pointer flex items-center justify-center text-lg"
              style={{
                width: "40px",
                height: "42px",
                background: "#fff",
                borderRadius: "50%",
                color: "var(--color-app-red)",
                fontWeight: "600",
                zIndex: 99,
              }}
            >
              ☰
            </div>
          )}
          {/* <div
            className="cursor-pointer flex-shrink-0 pl-2"
            onClick={() =>
              navigate(NavigationRoutes.DASHBOARD_ROUTES.DASHBOARD)
            }
          >
            <img src={Logo} width={120} height={40} alt="Local Locker Logo" />
          </div> */}
        </div>

        <AppHeader />
      </Header>

      {/* Main Layout - Sidebar and Content */}
      <div className="flex h-full ">
        {isMobileView ? (
          <Drawer
            placement="left"
            closable={true}
            maskClosable={true}
            mask={false}
            onClose={toggleSidebar}
            zIndex={1000}
            open={isSidebarVisible}
            className="w-[var(--side-bar-width)]"
          >
            <SideBar {...sideBarParams} />
          </Drawer>
        ) : (
          <SideBar {...sideBarParams} />
        )}

        {/* Main Content Area */}
        <div className="flex-1 bg-gray-50 mt-[70px] h-[calc(100vh-70px)] overflow-hidden">
          <Content
            style={{
              padding: "20px",
            }}
            className="h-full overflow-y-auto custom-scrollbar"
          >
            <div className="!mb-20 relative">
              <Suspense fallback={<LogoLoader mode="fullscreen" />}>
                <Outlet />
              </Suspense>
            </div>
          </Content>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
